import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import lightGallery from 'lightgallery';
import lightGalleryCSS from 'lightgallery/dist/css/lightgallery.css';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      // $('.l-footer__block').on('click', function () {
      //   $(this).children(".l-footer__menutitle").toggleClass('is-open');
      //   $(this).children(".l-footer__menulist.is-sub").slideToggle();
      // })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-recruit-main__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/XXXX-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/XXXX-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }

    function startAnimation() {
      // 1. 真っ白な画面がフェードアウト
      // 2. 「CHANGE is」が下からのスライドイン
      // 3. 「CHANGE is」の横の線が伸びる
      // 4. 左から矢印が伸びてくると同時に「CHANGE」が下からスライドイン
      // 5. 「CHANGE」→「NGE」が元の場所にスライド
      // 6. 下から「LLE」がスライドインするのと同時に「CHALLENGE」が青色になる

      var $loader = document.querySelector(".c-loader");
      var $body = document.querySelector("body");
      var $mainVisual = document.querySelector(".c-main-visual");
      var $mainVisualCatch = document.querySelector(".c-main-visual__catch");
      var $mainVisualBtn = document.querySelector(".c-main-visual__recruit-btn");
      var $mainVisualText = document.querySelector(".c-main-visual__text");
      var $mainVisualSubText = document.querySelector(".c-main-visual__subtext");

      function changeClass(el, className, time) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            el.classList.add(className);
            resolve(className);
          }, time);
        });
      }

      if ($loader) {
        changeClass($loader, "is-trigger-01", 1000).then(function () {
          changeClass($mainVisualCatch, "is-trigger-02", 800).then(function () {
            $mainVisual.classList.add("is-animation-start");
            changeClass($mainVisualCatch, "is-trigger-03", 500).then(function () {
              changeClass($mainVisualCatch, "is-trigger-04", 800).then(function () {
                changeClass($mainVisualCatch, "is-trigger-05", 800).then(function () {
                  changeClass($mainVisualBtn, "is-trigger-06", 1400).then(function () {
                    $mainVisualText.classList.add("is-trigger-06");
                    $mainVisualSubText.classList.add("is-trigger-06");
                  });
                });
              });
            });
          });
        });
      }
    }

    /**
     * ループスライダー
     */
    function loopSlider() {
      var targetInner = $('.c-loop-slider__inner'),
        targetInnerUl = $('.c-loop-slider__inner > ul'),
        targetInnerItems = targetInnerUl.children(),
        slideEasing = 'linear',
        slideSpeed = 4000;
      for (var i = 0; i < 2; i++) {
        targetInnerItems.clone().prependTo(targetInnerUl);
        targetInnerItems.clone().appendTo(targetInnerUl);
      }
      targetInnerUl.each(function () {
        var self = $(this);
        //liの個数を取得
        var selfChildItemLength = self.find('li').length;
        //liの幅を取得
        var selfChildList = self.find('li').innerWidth();
        //ulを複製する
        // self.clone().appendTo( targetInner );
        //ulの親divに幅を付与する
        // targetInner.width( ( selfChildList * selfChildItemLength ) * 2 )
        targetInner.width(selfChildList * selfChildItemLength);

        // 親divをアニメーションさせる
        function galleryAnimate() {
          targetInner.animate(
            {
              left: '-' + ((selfChildList * selfChildItemLength) / 3 * 2) + 'px'
            }, {
              duration: slideSpeed * selfChildItemLength,
              easing: slideEasing,
              complete: function () {
                targetInner.css({
                  left: 0
                });
                galleryAnimate()
              }
            }
          );
        }

        galleryAnimate()
      });
    }

    function reveal() {
//- スクロールリーバル
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".c-opening__title", {
        viewFactor: 1,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-recruit-opening__title", {
        viewFactor: 1,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-opening__text", {
        viewFactor: 0.4,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-recruit-opening__text", {
        viewFactor: 0.4,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-top-recruit__image", {
        viewFactor: 0.3,
        scale: 1,
        duration: 600,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-top-recruit__bg-text", {
        viewFactor: 0.9,
        scale: 1,
        duration: 600,
        origin: 'right',
        distance: '20px',
      }, 100);
      sr.reveal(".c-recruit-main__text", {
        viewFactor: 0,
        scale: 1,
        duration: 800,
        delay: 300,
        origin: 'right',
        distance: '20px',
      }, 100);
      sr.reveal(".c-recruit-main__subtext", {
        viewFactor: 0,
        scale: 1,
        duration: 800,
        delay: 300,
        origin: 'left',
        distance: '20px',
      }, 100);

      var blocks01 = $(".c-top-service .c-service-card__wrap");
      domEach(blocks01, function (key, item) {
        // sr.reveal(item, {viewFactor: 0.3, duration: 300, delay: 0, scale: 1, origin: 'bottom', distance: '20px'}, 0);
        // sr.reveal(item.children[0], {
        //   viewFactor: 0.3,
        //   duration: 300,
        //   delay: 200,
        //   scale: 1,
        //   origin: 'top',
        //   distance: '20px'
        // }, 0);
        // sr.reveal(item.children[1], {
        //   viewFactor: 0.3,
        //   duration: 300,
        //   delay: 200,
        //   scale: 1,
        //   origin: 'bottom',
        //   distance: '20px'
        // }, 0);
        // sr.reveal(item.children[2], {
        //   viewFactor: 0.3,
        //   duration: 300,
        //   delay: 200,
        //   scale: 1,
        //   origin: 'top',
        //   distance: '20px'
        // }, 0);
      });

      var blocks02 = $(".c-recruit-company .c-hero-block-down__block, .c-recruit-culture .c-hero-block-down__block");
      domEach(blocks02, function (key, item) {
        sr.reveal(item, {duration: 500, delay: 0, scale: 1, origin: 'top', distance: '20px'}, 200);
        sr.reveal(item.children[0], {duration: 500, delay: 200, scale: 1, origin: 'bottom', distance: '20px'}, 100);
        sr.reveal(item.children[1], {duration: 500, delay: 400, scale: 1, origin: 'top', distance: '20px'}, 100);
        sr.reveal(item.children[2], {duration: 500, delay: 600, scale: 1, origin: 'bottom', distance: '20px'}, 100);
        sr.reveal(item.children[3], {duration: 500, delay: 800, scale: 1, origin: 'top', distance: '20px'}, 100);
        sr.reveal(item.children[4], {duration: 500, delay: 1000, scale: 1, origin: 'bottom', distance: '20px'}, 100);
        sr.reveal(item.children[5], {duration: 500, delay: 1200, scale: 1, origin: 'top', distance: '20px'}, 100);
      });

      function myCallback(el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('#example', {beforeReveal: myCallback});
    }

    // lightGallery
    function lightGallery() {
      var $lg = $('.js-lightgallery').lightGallery({
        // selector: '.js-lightgallery-item',
        mode: 'lg-fade',
        loop: false,
        download: false,
        hideBarsDelay: 1000
      });
      $lg.on("onAfterOpen.lg", function (event) {
        // console.log(event);
        // $(".lg-inner").html($(".lg-inner .lg-item").get().reverse());

        $lg.data('lightGallery').slide($(".lg-inner .lg-item").length - 1);

      });
    }


    $(
      function () {
        menuSlide();
        owlCarousel();
        startAnimation();
        loopSlider();
        reveal();
        lightGallery();
      }
    )
    ;
  }
}

window.GApp = new App();
